import { Component } from '@angular/core';

@Component({
  selector: 'app-chevron-double-right-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './chevron-double-right-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class ChevronDoubleRightIconComponent {}
